module.exports = __webpack_public_path__ + "img/placeholder.fa19fa6b.png";